const EntertainClinetComponent = () => import('@/views/finance/EntertainClient/EntertainClientView')

export default [
    {
        path:'/EntertainClientIndex',
        name:'EntertainClientComponent',
        component:EntertainClinetComponent
    }
]